import { Icon } from '@iconify/react/dist/iconify.js';



const PlantationRecommendationCard = ({ recommendation }) => {
  if (!recommendation) return null;
  
  return (
    <div className="recommendation-card animation-text-3 mt-4">
      <div className="recommendation-header">
        <div className="recommendation-icon">
          <Icon icon="mdi:lightbulb-on-outline" />
        </div>
        <h6 className=''>Planting Recommendation</h6>
      </div>
      
      <div className="recommendation-content">
        <div className="recommendation-main">
          <div className="plant-suggestion">
            <div className="plant-icon">
              <Icon icon="mdi:tree" />
            </div>
            <div className="plant-details">
              <h4>Plant Name: {recommendation.plantName}</h4>
              <p className="scientific-name">{recommendation.scientificName}</p>
            </div>
          </div>
          
          <div className="recommendation-reasons">
            <h5>Why this plant is ideal:</h5>
            <ul>
              {recommendation.reasons.map((reason, index) => (
                <li key={index}>
                  <Icon icon="mdi:check-circle" className="reason-check" />
                  {reason}
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        <div className="recommendation-details">
          <div className="detail-item">
            <Icon icon="mdi:calendar" />
            <div>
              <span className="detail-label">Best Planting Time</span>
              <span className="detail-value">{recommendation.plantingSeason}</span>
            </div>
          </div>
          
          <div className="detail-item">
            <Icon icon="mdi:thermometer" />
            <div>
              <span className="detail-label">Optimal Temperature</span>
              <span className="detail-value">{recommendation.temperatureRange}</span>
            </div>
          </div>
          
          <div className="detail-item">
            <Icon icon="mdi:water" />
            <div>
              <span className="detail-label">Water Requirements</span>
              <span className="detail-value">{recommendation.waterNeeds}</span>
            </div>
          </div>
          
          <div className="detail-item">
            <Icon icon="mdi:weather-cloudy" />
            <div>
              <span className="detail-label">Climate Suitability</span>
              <span className="detail-value">{recommendation.climateSuitability}/10</span>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        .recommendation-card {
          background: linear-gradient(135deg, #f8fdf9 0%, #e8f5e9 100%);
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(56, 142, 60, 0.15);
          border: 1px solid #c8e6c9;
          margin-bottom: 2rem;
        }
        
        .recommendation-header {
          background: linear-gradient(135deg, #2e7d32 0%, #4caf50 100%);
          color: white;
          padding: 1.5rem;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        
        .recommendation-icon {
          background: rgba(255, 255, 255, 0.2);
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
        }
        
        .recommendation-header h6 {
          margin: 0;
          font-weight: 600;
          font-size: 0.5rem;
          color: #ffffff;
        }
        
        .recommendation-content {
          padding: 2rem;
        }
        
        .recommendation-main {
          margin-bottom: 2rem;
        }
        
        .plant-suggestion {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 1.5rem;
          padding: 1.5rem;
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        }
        
        .plant-icon {
          background: linear-gradient(135deg, #4caf50 0%, #81c784 100%);
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 2rem;
        }
        
        .plant-details h4 {
          margin: 0 0 4px 0;
          color: #2e7d32;
          font-weight: 600;
        }
        
        .scientific-name {
          margin: 0;
          font-style: italic;
          color: #78909c;
          font-size: 0.9rem;
        }
        
        .recommendation-reasons h5 {
          margin: 0 0 12px 0;
          color: #455a64;
          font-weight: 600;
        }
        
        .recommendation-reasons ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .recommendation-reasons li {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          margin-bottom: 10px;
          color: #546e7a;
        }
        
        .reason-check {
          color: #4caf50;
          flex-shrink: 0;
          margin-top: 2px;
        }
        
        .recommendation-details {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1rem;
        }
        
        .detail-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 1rem;
          background: white;
          border-radius: 10px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        }
        
        .detail-item svg {
          color: #4caf50;
          font-size: 1.5rem;
          flex-shrink: 0;
        }
        
        .detail-label {
          display: block;
          font-size: 0.8rem;
          color: #78909c;
          margin-bottom: 4px;
        }
        
        .detail-value {
          display: block;
          font-weight: 600;
          color: #455a64;
        }
        
        @media (max-width: 768px) {
          .recommendation-details {
            grid-template-columns: 1fr;
          }
          
          .plant-suggestion {
            flex-direction: column;
            text-align: center;
          }
        }
      `}</style>
    </div>
  );
};
export default PlantationRecommendationCard;